// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_room_artifacts.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_room_artifacts.proto.
 */
export const file_plugnmeet_room_artifacts: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * FileInfo contains details about a generated file artifact.
 *
 * @generated from message plugnmeet.RoomArtifactFileInfo
 */
export type RoomArtifactFileInfo = Message<"plugnmeet.RoomArtifactFileInfo"> & {
  /**
   * @generated from field: string file_path = 1;
   */
  filePath: string;

  /**
   * @generated from field: int64 file_size = 2 [jstype = JS_STRING];
   */
  fileSize: string;

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;
};

/**
 * Describes the message plugnmeet.RoomArtifactFileInfo.
 * Use `create(RoomArtifactFileInfoSchema)` to create a new message.
 */
export const RoomArtifactFileInfoSchema: GenMessage<RoomArtifactFileInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 0);

/**
 * ProviderJobInfo contains details about an asynchronous job sent to a provider.
 *
 * @generated from message plugnmeet.RoomArtifactProviderJobInfo
 */
export type RoomArtifactProviderJobInfo = Message<"plugnmeet.RoomArtifactProviderJobInfo"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * Describes the message plugnmeet.RoomArtifactProviderJobInfo.
 * Use `create(RoomArtifactProviderJobInfoSchema)` to create a new message.
 */
export const RoomArtifactProviderJobInfoSchema: GenMessage<RoomArtifactProviderJobInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 1);

/**
 * UserInfo contains details about the user associated with an artifact.
 *
 * @generated from message plugnmeet.RoomArtifactUserInfo
 */
export type RoomArtifactUserInfo = Message<"plugnmeet.RoomArtifactUserInfo"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactUserInfo.
 * Use `create(RoomArtifactUserInfoSchema)` to create a new message.
 */
export const RoomArtifactUserInfoSchema: GenMessage<RoomArtifactUserInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 2);

/**
 * @generated from message plugnmeet.RoomArtifactTokenUsage
 */
export type RoomArtifactTokenUsage = Message<"plugnmeet.RoomArtifactTokenUsage"> & {
  /**
   * @generated from field: uint32 prompt_tokens = 1;
   */
  promptTokens: number;

  /**
   * @generated from field: uint32 completion_tokens = 2;
   */
  completionTokens: number;

  /**
   * @generated from field: uint32 total_tokens = 3;
   */
  totalTokens: number;

  /**
   * @generated from field: map<string, int64> breakdown = 4;
   */
  breakdown: { [key: string]: bigint };

  /**
   * @generated from field: optional double prompt_tokens_estimated_cost = 5;
   */
  promptTokensEstimatedCost?: number | undefined;

  /**
   * @generated from field: optional double completion_tokens_estimated_cost = 6;
   */
  completionTokensEstimatedCost?: number | undefined;

  /**
   * @generated from field: optional double total_tokens_estimated_cost = 7;
   */
  totalTokensEstimatedCost?: number | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactTokenUsage.
 * Use `create(RoomArtifactTokenUsageSchema)` to create a new message.
 */
export const RoomArtifactTokenUsageSchema: GenMessage<RoomArtifactTokenUsage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 3);

/**
 * @generated from message plugnmeet.RoomArtifactDurationUsage
 */
export type RoomArtifactDurationUsage = Message<"plugnmeet.RoomArtifactDurationUsage"> & {
  /**
   * @generated from field: uint32 duration_sec = 1;
   */
  durationSec: number;

  /**
   * @generated from field: map<string, int64> breakdown = 2;
   */
  breakdown: { [key: string]: bigint };

  /**
   * @generated from field: optional double duration_sec_estimated_cost = 3;
   */
  durationSecEstimatedCost?: number | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactDurationUsage.
 * Use `create(RoomArtifactDurationUsageSchema)` to create a new message.
 */
export const RoomArtifactDurationUsageSchema: GenMessage<RoomArtifactDurationUsage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 4);

/**
 * @generated from message plugnmeet.RoomArtifactCharacterCountUsage
 */
export type RoomArtifactCharacterCountUsage = Message<"plugnmeet.RoomArtifactCharacterCountUsage"> & {
  /**
   * @generated from field: uint32 total_characters = 1;
   */
  totalCharacters: number;

  /**
   * @generated from field: map<string, int64> breakdown = 2;
   */
  breakdown: { [key: string]: bigint };

  /**
   * @generated from field: optional double total_characters_estimated_cost = 3;
   */
  totalCharactersEstimatedCost?: number | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactCharacterCountUsage.
 * Use `create(RoomArtifactCharacterCountUsageSchema)` to create a new message.
 */
export const RoomArtifactCharacterCountUsageSchema: GenMessage<RoomArtifactCharacterCountUsage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 5);

/**
 * RoomArtifactMetadata is the universal structure for the 'metadata' JSON field
 * in the pnm_room_artifacts table. All fields are optional.
 *
 * @generated from message plugnmeet.RoomArtifactMetadata
 */
export type RoomArtifactMetadata = Message<"plugnmeet.RoomArtifactMetadata"> & {
  /**
   * Optional: Information about the user who initiated or is associated with the artifact.
   *
   * @generated from field: plugnmeet.RoomArtifactUserInfo user_info = 1;
   */
  userInfo?: RoomArtifactUserInfo | undefined;

  /**
   * Optional: Information about an asynchronous provider job.
   *
   * @generated from field: plugnmeet.RoomArtifactProviderJobInfo provider_job_info = 2;
   */
  providerJobInfo?: RoomArtifactProviderJobInfo | undefined;

  /**
   * Optional: Information about the final generated file artifact.
   *
   * @generated from field: plugnmeet.RoomArtifactFileInfo file_info = 3;
   */
  fileInfo?: RoomArtifactFileInfo | undefined;

  /**
   * A field for different types of usage metrics.
   *
   * @generated from oneof plugnmeet.RoomArtifactMetadata.usage_details
   */
  usageDetails: {
    /**
     * @generated from field: plugnmeet.RoomArtifactTokenUsage token_usage = 4;
     */
    value: RoomArtifactTokenUsage;
    case: "tokenUsage";
  } | {
    /**
     * @generated from field: plugnmeet.RoomArtifactDurationUsage duration_usage = 5;
     */
    value: RoomArtifactDurationUsage;
    case: "durationUsage";
  } | {
    /**
     * @generated from field: plugnmeet.RoomArtifactCharacterCountUsage character_count_usage = 6;
     */
    value: RoomArtifactCharacterCountUsage;
    case: "characterCountUsage";
  } | { case: undefined; value?: undefined };

  /**
   * A field to link a file artifact back to its usage artifact.
   *
   * @generated from field: optional string reference_artifact_id = 10;
   */
  referenceArtifactId?: string | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactMetadata.
 * Use `create(RoomArtifactMetadataSchema)` to create a new message.
 */
export const RoomArtifactMetadataSchema: GenMessage<RoomArtifactMetadata> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 6);

/**
 * Webhook-specific Messages
 *
 * @generated from message plugnmeet.RoomArtifactWebhookEvent
 */
export type RoomArtifactWebhookEvent = Message<"plugnmeet.RoomArtifactWebhookEvent"> & {
  /**
   * @generated from field: plugnmeet.RoomArtifactType type = 1;
   */
  type: RoomArtifactType;

  /**
   * @generated from field: string artifact_id = 2;
   */
  artifactId: string;

  /**
   * @generated from field: plugnmeet.RoomArtifactMetadata metadata = 3;
   */
  metadata?: RoomArtifactMetadata | undefined;
};

/**
 * Describes the message plugnmeet.RoomArtifactWebhookEvent.
 * Use `create(RoomArtifactWebhookEventSchema)` to create a new message.
 */
export const RoomArtifactWebhookEventSchema: GenMessage<RoomArtifactWebhookEvent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_room_artifacts, 7);

/**
 * @generated from enum plugnmeet.RoomArtifactType
 */
export enum RoomArtifactType {
  /**
   * @generated from enum value: UNKNOWN_ARTIFACT = 0;
   */
  UNKNOWN_ARTIFACT = 0,

  /**
   * @generated from enum value: MEETING_ANALYTICS = 1;
   */
  MEETING_ANALYTICS = 1,

  /**
   * @generated from enum value: MEETING_SUMMARY = 2;
   */
  MEETING_SUMMARY = 2,

  /**
   * @generated from enum value: MEETING_SUMMARY_USAGE = 3;
   */
  MEETING_SUMMARY_USAGE = 3,

  /**
   * @generated from enum value: SPEECH_TRANSCRIPTION = 4;
   */
  SPEECH_TRANSCRIPTION = 4,

  /**
   * @generated from enum value: SPEECH_TRANSCRIPTION_USAGE = 5;
   */
  SPEECH_TRANSCRIPTION_USAGE = 5,

  /**
   * @generated from enum value: SYNTHESIZED_SPEECH_USAGE = 6;
   */
  SYNTHESIZED_SPEECH_USAGE = 6,

  /**
   * @generated from enum value: CHAT_TRANSLATION_USAGE = 7;
   */
  CHAT_TRANSLATION_USAGE = 7,

  /**
   * @generated from enum value: AI_TEXT_CHAT_INTERACTION_USAGE = 8;
   */
  AI_TEXT_CHAT_INTERACTION_USAGE = 8,

  /**
   * @generated from enum value: AI_TEXT_CHAT_SUMMARIZATION_USAGE = 9;
   */
  AI_TEXT_CHAT_SUMMARIZATION_USAGE = 9,
}

/**
 * Describes the enum plugnmeet.RoomArtifactType.
 */
export const RoomArtifactTypeSchema: GenEnum<RoomArtifactType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_room_artifacts, 0);

